// extracted by mini-css-extract-plugin
export default {"center":"index_center__bTZ9r"};